import api from "../index"

const reports = api.injectEndpoints({
  endpoints: (build) => ({
    getWealthReportsData: build.query({
      query: ({ date }) => ({
        url: `/wealthPartner/reports/financial-report?date=${encodeURIComponent(
          JSON.stringify(date)
        )}`,
        method: "GET",
      }),
    }),
    getWealthAdminOffers: build.query({
      query: () => ({
        url: `/wealthPartner/reports/admin/offers`,
        method: "GET",
      }),
    }),
    getWealthDashboardStats: build.query({
      query: () => ({
        url: `/wealthPartner/reports/dashboard/stats`,
        method: "GET",
      }),
    }),
    getWealtDashboardPayableAmountChart: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/payable/amount/chart`,
        method: "POST",
        body,
      }),
    }),
    getWealtDashboardCompaniesAgreements: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/agreements`,
        method: "POST",
        body,
      }),
    }),
    getDashboardReferralTracking: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/referral/tracking`,
        method: "POST",
        body,
      }),
    }),
    getDashboardMaturityTracking: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/maturity`,
        method: "POST",
        body,
      }),
    }),
    getDashboardTopPerformer: build.query({
      query: (body) => ({
        url: `/wealthPartner/reports/dashboard/top/performer`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetWealthReportsDataQuery,
  useLazyGetWealthAdminOffersQuery,
  useLazyGetWealthDashboardStatsQuery,
  useLazyGetWealtDashboardPayableAmountChartQuery,
  useLazyGetWealtDashboardCompaniesAgreementsQuery,
  useLazyGetDashboardReferralTrackingQuery,
  useLazyGetDashboardMaturityTrackingQuery,
  useLazyGetDashboardTopPerformerQuery,
} = reports
